import SectionHeading from "./SectionHeading";
import { rankItems } from "@/mocks/home";

const toNumber = (value: string) => Number(value.replace(/,/g, ""));
const maxHeat = Math.max(...rankItems.map((item) => toNumber(item.heat)));

export default function RankSection() {
  const top = rankItems[0];
  const rest = rankItems.slice(1);

  return (
    <section id="rank" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <SectionHeading
          id="rank"
          kicker="热门榜"
          title="本周被查阅最多的黑料大全"
          desc="按近七日查阅量排序，榜单每天凌晨刷新一次，适合想快速了解大家在关注哪类合集的时候使用。"
          actionLabel="完整榜单"
          actionHref="#discussion"
          actionIcon="ri-bar-chart-box-line"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-lg border border-primary-200 bg-primary-50 p-6">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                  1
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium text-primary-700">
                  <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  榜首
                </span>
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold leading-snug text-foreground-950">
                {top.name}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                本周查阅量持续领跑，新增背景脉络章节后关注度进一步上升，是第一次浏览黑料bu时的推荐入口。
              </p>
              <div className="mt-auto pt-6">
                <div className="flex items-end justify-between">
                  <span className="font-heading text-3xl font-bold text-primary-700">{top.heat}</span>
                  <span className="inline-flex items-center gap-1 font-label text-xs font-medium text-primary-600">
                    <i className="ri-arrow-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {top.trend}
                  </span>
                </div>
                <a
                  href="#collections"
                  className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  查看该合集
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="space-y-3">
              {rest.map((item, index) => {
                const pct = Math.round((toNumber(item.heat) / maxHeat) * 100);
                return (
                  <li
                    key={item.id}
                    className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 md:p-5"
                  >
                    <div className="flex items-center gap-4">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-heading text-base font-bold text-secondary-800">
                        {index + 2}
                      </span>
                      <div className="min-w-0 flex-1">
                        <h4 className="truncate font-heading text-base font-semibold text-foreground-950">
                          <a href="#collections" className="cursor-pointer hover:text-primary-700">
                            {item.name}
                          </a>
                        </h4>
                        <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                          <div
                            className="h-full rounded-full bg-secondary-500"
                            style={{ width: `${pct}%` }}
                          ></div>
                        </div>
                      </div>
                      <div className="shrink-0 text-right">
                        <span className="block font-heading text-base font-bold text-foreground-900">
                          {item.heat}
                        </span>
                        <span
                          className={`inline-flex items-center gap-0.5 font-label text-xs ${
                            item.up ? "text-accent-700" : "text-foreground-500"
                          }`}
                        >
                          <i
                            className={`${
                              item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"
                            } w-3 h-3 flex items-center justify-center`}
                          ></i>
                          {item.trend}
                        </span>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}